var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-search-wrap"},[_vm._v(" 搜索 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }